import axios from 'axios';
import { useQuery, UseQueryResult } from 'react-query';

import { useHelpCenterInstance } from '../../../providers/HelpCenterInstance';
import SelfServeApi from '../api';
import { CUSTOMER_ID, QUERY_ORDERS } from '../constants';
import customerDetails from '../customerDetails';
import { CustomerCredentials, OrderList } from '../types';
import { handleLogout } from '../utils/handleLogout';

async function getOrders(
  customer: CustomerCredentials,
  shopName?: string | null,
): Promise<OrderList> {
  const sspApi = new SelfServeApi();

  try {
    const {
      data: {
        orders,
        customer: { id },
      },
    } = await sspApi.getShopifyOrders({
      ...customer,
      // @ts-expect-error shopName can be null | undefined
      shopName,
    });

    customerDetails.setCustomerDetails({ [CUSTOMER_ID]: id.toString() });

    return orders;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response?.status === 403) {
      handleLogout();
    }

    throw err;
  }
}

export function useOrders(
  isWaitingForCredentials = true,
): UseQueryResult<OrderList, unknown> {
  const helpCenter = useHelpCenterInstance();

  const badStatuses: (number | undefined)[] = [403, 404];

  return useQuery(
    [QUERY_ORDERS],
    () => getOrders(customerDetails.getCustomerDetails(), helpCenter.shopName),
    {
      enabled: !isWaitingForCredentials,
      retry: (failureCount, err) => {
        if (
          axios.isAxiosError(err) &&
          badStatuses.includes(err.response?.status)
        ) {
          return false;
        }

        return failureCount <= 3;
      },
      refetchOnWindowFocus: false,
    },
  );
}

export default useOrders;
